import { Component, Inject, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AiPhoto { id: number; url: string; width: number; height: number; blurred: boolean; }
export interface PhotoViewerData {
  photos: AiPhoto[];
  startIndex: number;
  title?: string;
}

@Component({
  selector: 'app-mint-girl-photo-viewer',
  templateUrl: './mint-girl-photo-viewer.component.html',
  styleUrls: ['./mint-girl-photo-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MintGirlPhotoViewerComponent {
  index = 0;
  readonly photos = this.data.photos ?? [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PhotoViewerData,
    private dialogRef: MatDialogRef<MintGirlPhotoViewerComponent>
  ) {
    const len = this.photos.length;
    this.index = Math.max(0, Math.min(data.startIndex ?? 0, Math.max(0, len - 1)));
  }

  get length(): number { return this.photos.length; }
  get photo(): AiPhoto | undefined { return this.photos[this.index]; }

  next(ev?: Event) {
    ev?.stopPropagation();
    if (!this.length) return;
    this.index = (this.index + 1) % this.length;
  }

  prev(ev?: Event) {
    ev?.stopPropagation();
    if (!this.length) return;
    this.index = (this.index - 1 + this.length) % this.length;
  }

  // ESC to close 
  @HostListener('document:keydown', ['$event'])
  onKey(ev: KeyboardEvent) {
    if (ev.key === 'ArrowRight') { this.next(); }
    else if (ev.key === 'ArrowLeft') { this.prev(); }
    else if (ev.key === 'Escape') { this.dialogRef.close(); }
  }
}
